import { useEffect } from 'react';
declare global {
  interface Window {
    TrelloPowerUp: any;
    ga: any;
    Trello: any;
  }
}

const SERVER_URL = process.env.REACT_APP_SERVER_URL || 'http://localhost:3001';

const getSubscription = async (jwt: string) => {
  const response = await fetch(`${SERVER_URL}/payments/subscription`, {
    method: 'post',
    body: JSON.stringify({ jwt, powerUp: 'galleryView' }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (response.ok) {
    return response.json();
  } else {
    throw new Error(`Failed with status code: ${response.status}`);
  }
};

export const getTrial = async (jwt: string) => {
  const response = await fetch(`${SERVER_URL}/trials/jwt`, {
    method: 'post',
    body: JSON.stringify({ jwt, powerUp: 'galleryView' }),
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (response.ok) {
    return response.json();
  } else {
    throw new Error(`Failed with status code: ${response.status}`);
  }
};

async function checkSubscription(t: any) {
  const subscriptionMap =
    (await t.get('board', 'shared', 'subscriptionMap')) || {};
  const me = await t.member('id');
  const isAuthorized: boolean = await t.getRestApi().isAuthorized();

  if (t.isMemberSignedIn() && isAuthorized) {
    if (subscriptionMap[me.id]) {
      const mySubscription = subscriptionMap[me.id];

      const lastUpdated = new Date(mySubscription.lastUpdated);
      const now = new Date();
      const diff = now.getTime() - lastUpdated.getTime();
      const diffDays = Math.ceil(diff / (1000 * 3600 * 24));

      if (diffDays === 1) {
        return;
      }
    }

    const token = await t.getRestApi().getToken();
    const jwt = await t.jwt({
      state: JSON.stringify({ token }),
    });
    const subscription = await getSubscription(jwt);

    let hasSubscription =
      subscription.individual ||
      subscription.workspace ||
      subscription.status === 'active';

    if (!hasSubscription) {
      const trial = await getTrial(jwt);
      const trialDate = new Date(trial.trialEnds);
      hasSubscription = new Date() < trialDate;
    }

    if (hasSubscription) {
      subscriptionMap[me.id] = {
        lastUpdated: new Date().toISOString(),
      };

      t.set('board', 'shared', 'subscriptionMap', subscriptionMap);
    } else {
      delete subscriptionMap[me.id];
      t.set('board', 'shared', 'subscriptionMap', subscriptionMap);
    }
  }
}

function getAccentColor(t: any) {
  const context = t.getContext();

  const theme = context.theme ?? context.initialTheme ?? 'light';

  if (theme === 'light') {
    return '#FFFFFF';
  }

  return '#1D2125';
}

const initialize = () => {
  window.TrelloPowerUp.initialize(
    {
      'board-buttons': async (t: any) => {
        checkSubscription(t);

        let condition = 'edit';

        const isGuest =
          !t.isMemberSignedIn() || !t.memberCanWriteToModel('board');

        if (isGuest) {
          const subscriptionMap =
            (await t.get('board', 'shared', 'subscriptionMap')) || {};

          if (Object.keys(subscriptionMap).length > 0) {
            condition = 'always';
          }
        }

        return [
          {
            text: 'Gallery',
            icon: './gallery-view-icon.png',
            callback: (x: any) => {
              x.modal({
                title: 'Gallery View',
                url: `./modal?isGuest=${isGuest}`,
                accentColor: getAccentColor(x),
                fullscreen: true,
              });
            },
            condition,
          },
        ];
      },

      'show-settings': async (t: any) => {
        const isAuthorized: boolean = await t.getRestApi().isAuthorized();

        if (!isAuthorized) {
          t.popup({
            title: 'Gallery View - Settings',
            items: [
              {
                text: 'Authorize',
                callback: (x: any) => {
                  x.popup({
                    title: 'Authorize Gallery View',
                    url: './authorize',
                    height: 260,
                  });
                },
              },
            ],
          });

          return;
        }

        t.popup({
          title: 'Gallery View - Settings',
          items: [
            {
              text: 'Manage subscription...',
              callback: async (x: any) => {
                return x.modal({
                  title: 'Gallery View - Subscription',
                  url: './payment',
                  fullscreen: true,
                });
              },
            },
          ],
        });
      },
    },
    {
      appKey: '7c1c5563efb6aad71cdaa4a8a05abd0d',
      appName: 'Gallery View',
      localization: {
        defaultLocale: 'en',
        supportedLocales: ['en'],
        resourceUrl: './strings/{locale}.json',
      },
    }
  );
};

export const IframeConnector = () => {
  useEffect(() => {
    initialize();
  }, []);

  return <div>ok</div>;
};
